import { Box, Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '40px',
    display: 'flex',
    padding: '40px 20px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F7FDF8',
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)',
  },
  title: {
    color: '#212121',
    textAlign: 'center',
    fontFamily: 'Playfair Display',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '54px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '24px',
      lineHeight: '36px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
      lineHeight: '30px',
    },
  },
  description: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Lato',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '27px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '21px',
    },
  },
  subscribeBtn: {
    backgroundColor: '#3C8047',
    color: '#fff',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    borderRadius: '0',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: 'rgb(42, 89, 49)',
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: '14px',
      padding: '8px 16px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      padding: '6px 12px',
    },
  },
}));

function StayInTouch() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography component="h1" className={classes.title}>
        Stay in Touch
      </Typography>
      <Typography component="p" className={classes.description}>
      Want to know more about what's going on at Baywood Greens? Subscribe to our VIP Newsletter to stay up to date on everything that's happening at your favorite course!
      </Typography>
      <Button href='https://mailchi.mp/baywoodgreens.com/baywood-vip-list' target='_blank' className={classes.subscribeBtn}>
        Subscribe to VIP newsletter
      </Button>
    </Box>
  );
}

export default StayInTouch;
